import { completeAuthRedirectIfPresent } from './auth/redirect-bridge-entry';

// When this page load is an MSAL sign-in response (popup, SSO iframe, or redirect),
// hand it to MSAL's redirect bridge and stop — the SPA must not boot on that load.
const handledAsAuthRedirect = await completeAuthRedirectIfPresent();

if (!handledAsAuthRedirect) {
  const runtimeConfigPath = '/runtime-config.js';
  await import(/* @vite-ignore */ runtimeConfigPath);
  await import('./main');
}

export {};
